/* eslint-disable @typescript-eslint/default-param-last */
import { ReduxAction } from '..';
import {
  CHAT_LOGIN,
  CHAT_VERIFY_OTP,
  CHAT_GET_CHATWOOT_TOKEN,
  CHAT_SET_AUTH_TOKEN,
  CHAT_SET_CHATWOOT_READY,
} from '../constants';
import { ReducerState } from './_prototype';

const initialState: ReducerState = {
  loginSession: null,
  loginSessionState: '',
  loginSessionError: null,

  verification: null,
  verificationState: '',
  verificationError: null,

  chatwootToken: null,
  chatwootTokenState: '',
  chatwootTokenError: null,

  chatAuthToken: '',
  isChatwootReady: false,
};

export default function actionReducer(
  state = initialState,
  action: ReduxAction
) {
  switch (action.type) {
    // LOGIN
    case `${CHAT_LOGIN}_PENDING`:
      return {
        ...state,
        loginSession: null,
        loginSessionState: 'loading',
        loginSessionError: null,
      };
    case `${CHAT_LOGIN}_FULFILLED`:
      return {
        ...state,
        loginSession: action.payload,
        loginSessionState: 'success',
        loginSessionError: null,
      };
    case `${CHAT_LOGIN}_REJECTED`:
      return {
        ...state,
        loginSession: null,
        loginSessionState: 'error',
        loginSessionError: action.payload,
      };
    case `${CHAT_LOGIN}_RESET`:
      return {
        ...state,
        loginSession: null,
        loginSessionState: '',
        loginSessionError: null,
      };

    // VERIFY OTP (verification)
    case `${CHAT_VERIFY_OTP}_PENDING`:
      return {
        ...state,
        verification: null,
        verificationState: 'loading',
        verificationError: null,
      };
    case `${CHAT_VERIFY_OTP}_FULFILLED`:
      return {
        ...state,
        verification: action.payload,
        verificationState: 'success',
        verificationError: null,
      };
    case `${CHAT_VERIFY_OTP}_REJECTED`:
      return {
        ...state,
        verification: null,
        verificationState: 'error',
        verificationError: action.payload,
      };

    // CHATWOOT TOKEN
    case `${CHAT_GET_CHATWOOT_TOKEN}_PENDING`:
      return {
        ...state,
        chatwootToken: null,
        chatwootTokenState: 'loading',
        chatwootTokenError: null,
      };
    case `${CHAT_GET_CHATWOOT_TOKEN}_FULFILLED`:
      return {
        ...state,
        chatwootToken: action.payload,
        chatwootTokenState: 'success',
        chatwootTokenError: null,
      };
    case `${CHAT_GET_CHATWOOT_TOKEN}_REJECTED`:
      return {
        ...state,
        chatwootToken: null,
        chatwootTokenState: 'error',
        chatwootTokenError: action.payload,
      };

    // Simple setters
    case CHAT_SET_AUTH_TOKEN:
      return { ...state, chatAuthToken: action.payload };
    case CHAT_SET_CHATWOOT_READY:
      return { ...state, isChatwootReady: action.payload };

    default:
      return state;
  }
}
